import React from 'react';
import { ParticipationFields, toggleParticipate } from './participation';

type AssessmentRow = ParticipationFields & { id: string };

export const useAssessmentRowActions = <T extends AssessmentRow>(setRows?: React.Dispatch<React.SetStateAction<T[]>>) => {
  const handleAmountChange = React.useCallback(
    (id: string, amount: string) => {
      setRows?.(prev => prev.map(row => (row.id === id ? { ...row, amount } : row)));
    },
    [setRows],
  );

  const handleParticipateToggle = React.useCallback(
    (id: string) => {
      setRows?.(prev => prev.map(row => (row.id === id ? toggleParticipate(row) : row)));
    },
    [setRows],
  );

  return { handleAmountChange, handleParticipateToggle };
};
